import { SvgIcon } from '@progress/kendo-react-common';
import React from 'react';
import { useFlightWorker } from '../../../app/hooks/use-flight-worker';
import { FlightTooltipDto } from '../../../flights/interop/flightDto';
import { DateTimeFormatter } from '../../../formatters';
import { BorderColorOutline } from '../../../icons/icons';
import { MessageType } from '../../../services/actor-messages';
import { FlightTooltipData } from '../../../services/map-interaction-service';
import tagFields from '../../../static/static-tag-fields';

export function FlightActiveTooltip(props: { info: FlightTooltipData }) {
    const tooltip = props.info;
    const [tooltipInfo, setTooltipInfo] = React.useState<FlightTooltipDto | null>(null);
    const worker = useFlightWorker();

    React.useEffect(() => {
        worker.actor.sendAsync({ type: MessageType.getFlightTooltip, data: tooltip.id }).then((info) => {
            setTooltipInfo(info);
        });
    }, [worker, tooltip?.id]);

    if (!tooltipInfo) {
        return <></>;
    }

    return (
        <div
            style={{
                width: 125,
                fontSize: 11,
                backgroundColor: 'var(--bg-color)',
                padding: '0.5em'
            }}>
            <div style={{ fontWeight: 500, width: '100%', display: 'grid', gridTemplateColumns: '1fr max-content 1fr', gridRowGap: 0 }}>
                <div style={{ fontSize: '1.25em', gridColumn: '1/4', gridRow: 1 }} className="text-center">
                    {tooltipInfo.acid}
                    {tooltipInfo.hasNotes && <SvgIcon icon={BorderColorOutline} />}
                </div>
                <div style={{ gridColumn: 1 }}>{tooltipInfo.origin || 'N/A'}</div>
                <div style={{ gridColumn: 3 }} className="text-end">
                    {tooltipInfo.destination || 'N/A'}
                </div>
                {tooltipInfo.progressPercentage != null && (
                    <div style={{ gridColumn: '1/4', height: 2, backgroundColor: 'var(--border-color)', margin: '0.125rem 2ch' }}>
                        <div
                            style={{
                                backgroundColor: 'var(--info-blue)',
                                width: `${tooltipInfo.progressPercentage}%`,
                                height: '100%'
                            }}></div>
                    </div>
                )}
                <div style={{ gridColumn: 1 }}>{DateTimeFormatter.formatTime(tooltipInfo.departureTime, 'hm') || '-'}</div>
                <div style={{ gridColumn: 3 }} className="text-end">
                    {DateTimeFormatter.formatTime(tooltipInfo.arrivalTime, 'hm') || '-'}
                </div>
            </div>
            {tooltipInfo.customFields.length > 0 && (
                <div className="w-100 border-top mt-1 pt-1">
                    {tooltipInfo.customFields.map((x, i) => (
                        <div className="d-flex gap-1 w-100" key={i}>
                            <div style={{ flexBasis: 0, flexGrow: 1 }}>{tagFields[x.field].name}</div>
                            <div style={{ flexBasis: 0, flexGrow: 1 }}>{x.value}</div>
                        </div>
                    ))}
                    {import.meta.env.DEV && <div className="font-mono">Flight ID: {tooltipInfo.id}</div>}
                </div>
            )}
        </div>
    );
}
